import { useRef, useState } from 'react';
import { cn } from '@divlab/divanui';

import styles from './Tabs.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';

interface Tab {
  id: number;
  label: string;
}

export interface TabsProps extends HTMLAttributes<HTMLDivElement> {
  tabs: Tab[];
  onChangeTab?: (id: number) => void;
}

const Tabs: FC<TabsProps> = (props) => {
  const { tabs, onChangeTab, className, ...restProps } = props;
  const [currentTab, setCurrentTab] = useState<number>(tabs[0].id);
  const currentItemRef = useRef<HTMLDivElement>();

  const onClick = (e: MouseEvent<HTMLDivElement>, id: number) => {
    currentItemRef.current = e.currentTarget;
    setCurrentTab(id);

    if (onChangeTab) onChangeTab(id);
  };

  const activeBarStyle = {
    width: currentItemRef.current?.offsetWidth,
    left: currentItemRef.current?.offsetLeft,
  };

  return (
    <div {...restProps}>
      <div className={cn(styles.tabs, className)}>
        {tabs.map((tab) => (
          <div
            key={tab.id}
            onClick={(e) => onClick(e, tab.id)}
            ref={currentTab === tab.id ? currentItemRef : null}
            className={cn(styles.tab, { [styles.active]: currentTab === tab.id })}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className={styles.scrollBar}>
        <span className={styles.activeBar} style={activeBarStyle} />
      </div>
    </div>
  );
};

export default Tabs;
